/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Mentions_Link_Space_DescriptionInputs */



/**
* | output |
* | --- |
* | "\"{name}\" is not linked to this project yet, so the assistant cannot read it. Linking it makes it available to everyone in the project." |
*
* @param {Chat_Mentions_Link_Space_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_space_description = /** @type {((inputs: Chat_Mentions_Link_Space_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_Space_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}“ ist noch nicht mit diesem Projekt verknüpft und kann daher nicht gelesen werden. Durch das Verknüpfen wird der Space für alle im Projekt verfügbar.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" is not linked to this project yet, so the assistant cannot read it. Linking it makes it available to everyone in the project.`)
});